import { View, Text } from "@react-pdf/renderer";
import InvoiceTotals from "./InvoiceTotals";
import styles from "./styles";
import FaNum from "./FaNum";

export default function InvoiceSummary({ order }) {
  const totalAmount = Number(order.data.amount || 0);
  const shipping = Number(order.data.shipping || 0);
  const discount = Number(order.data.discount || 0);
  const wallet = Number(order.data.wallet || 0);
  const paid = Number(order.data.amount) - Number(order.data.discount) - Number(order.data.wallet);

  return (
    <View style={styles.summaryBox}>
      <View style={styles.summaryRow}>
        <Text style={styles.extraRowTitle}>مبلغ کل سفارش</Text>
        <FaNum>{totalAmount}</FaNum>
      </View>

      <View style={styles.summaryRow}>
        <Text style={styles.extraRowTitle}>هزینه ارسال</Text>
        <FaNum>{shipping}</FaNum>
      </View>

      <View style={styles.summaryRow}>
        <Text style={styles.extraRowTitle}>تخفیف</Text>
        <FaNum>{discount}</FaNum>
      </View>

      <View style={styles.summaryRow}>
        <Text style={styles.extraRowTitle}>کیف پول</Text>
        <FaNum>{wallet}</FaNum>
      </View>

      {order.data.coupon > 0 && (
        <View style={styles.summaryRow}>
          <Text style={styles.extraRowTitle}>کد تخفیف</Text>
          <FaNum>{order.data.coupon}</FaNum>
        </View>
      )}

       <InvoiceTotals paid={paid} />
    </View>

    
  );
}
